"use client"

import DrawerSelectDate, { DrawerSelectDateRef } from "@/components/common/DrawerSelectDate"
import TEDatePicker from "@/components/common/TEDatePicker"
import Text from "@/components/common/Typography/Text"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useTERouter } from "@/hooks/app/useTERouter"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"

import { faCalendarAlt } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Card, Col, DatePicker, Row, theme } from "antd"
import { usePathname } from "next/navigation"
import { FC, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

type SelectDepartureDateProps = {}

const SelectDepartureDate: FC<SelectDepartureDateProps> = ({ }) => {
  const { getValidDayjs } = useTETranslation()
  const ref = useRef<HTMLDivElement>(null)
  const refDrawerSelectDate = useRef<DrawerSelectDateRef>(null)
  const [selector, setSelector] = useState<'from' | 'to' | undefined>()
  const departureDate = useAppSelector(state => state.tour.formSearch.departureDate)
  const tourCategory = useAppSelector(state => state.tour.formSearch.tourCategory)
  const [start, end] = [getValidDayjs(departureDate), getValidDayjs(null)]
  const isDesktop = useIsDesktop()
  const router = useTERouter()
  const dispatch = useAppDispatch()
  const pathname = usePathname()
  const { t } = useTranslation()

  const onChange = (value: any) => {
    const v = value 
      ? getValidDayjs(value[0]).format("YYYY-MM-DD")
      : null
    dispatch(tourActions.chooseDepartureDate(v))
    if (pathname.includes('/tours/category')) {
      router.push(`/tours/category/${tourCategory?.id}?start_date=${v || ""}`) 
    }
  }

  const content = (
    <Card
      ref={ref}
      size='small'
      variant='borderless'
      className="home__searching--placement"
      onClick={() => {
        if (!isDesktop) {
          refDrawerSelectDate.current?.open()
        }
      }}
    >
      <Row gutter={[30, 30]} wrap={false} align='middle' justify='space-between'>
        <Col flex={1} onClick={() => setSelector('from')}>
          <Row className="home__searching--input-label" align='middle' gutter={[5, 5]} wrap={false}>
            <Col>
              <Text>
                <FontAwesomeIcon icon={faCalendarAlt} />
              </Text>
            </Col>
            <Col>
              <Text>{t("tour.departure_date")}</Text>
            </Col>
          </Row>
          <Row>
            <DatePicker
              value={departureDate ? start : undefined}
              className={`home__searching--input home__searching--input-small${departureDate ? ' home__searching--date-selected' : ''}`}
              variant='borderless'
              allowClear
              open={false}
              format={'DD MMM'}
              placeholder={t(("tour.departure_date_placeholder"))}
              onChange={(val) => {
                if (!val) {
                  onChange(val)
                }
              }}
            />
          </Row>
        </Col>
      </Row>
    </Card>
  )

  if (!isDesktop) {
    return (
      <>
        <DrawerSelectDate
          ref={refDrawerSelectDate}
          range={false}
          onChange={onChange}
          value={departureDate ? [start, end] : undefined}
          selector={selector}
        />
        {content}
      </>
    )
  }

  return (
    <TEDatePicker
      minRangeLen={1}
      popupProps={{
        placement: 'bottomLeft'
      }}
      value={departureDate ? [start, end] : undefined}
      onChange={onChange}
      range={false}
      selector={selector}
    >
      {content}
    </TEDatePicker>
  )
}

export default SelectDepartureDate